import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/code.svg'
import _imports_2 from '../assets/save.svg'
import _imports_3 from '../assets/edit.svg'
import _imports_4 from '../assets/copy.svg'
import _imports_5 from '../assets/trash2.svg'
import _imports_6 from '../assets/edit_params.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d2a7a17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit Service", -1))
const _hoisted_6 = { class: "alignIcons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "code icon"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "32",
  width: "32",
  src: _imports_2,
  alt: "play icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Constant Value")
], -1))
const _hoisted_13 = { class: "action-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  height: "20",
  width: "20",
  alt: "inspect param"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  height: "20",
  width: "20",
  alt: "delete param"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value", "checked", "onChange"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "action-container" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "activeSave",
  src: _imports_3,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    height: "20",
    width: "20",
    alt: "copy param"
  })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    height: "20",
    width: "20",
    alt: "delete param"
  })
], -1))
const _hoisted_32 = { class: "table" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Constant Value")
], -1))
const _hoisted_34 = { class: "action-container" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  height: "20",
  width: "20",
  alt: "inspect param"
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  height: "20",
  width: "20",
  alt: "delete param"
}, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = ["value", "checked", "onChange"]
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "action-container" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "activeSave",
  src: _imports_6,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    height: "20",
    width: "20",
    alt: "copy param"
  })
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    height: "20",
    width: "20",
    alt: "delete param"
  })
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Server", -1))
const _hoisted_54 = {
  class: "del-container",
  style: { border: 'none' }
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 2,
  class: "grid-del-container"
}
const _hoisted_57 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!

  return (_ctx.ncStore.editingService !== undefined)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExitModal())),
                class: "icon-button"
              }, _hoisted_4),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCode()))
                }, _hoisted_8),
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
                }, _hoisted_10)
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input-style",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ncStore.editingService.name) = $event)),
              placeholder: "Enter Service Name ..."
            }, null, 512), [
              [_vModelText, _ctx.ncStore.editingService.name]
            ]),
            _createElementVNode("h3", null, [
              _createTextVNode(" Request Params "),
              _createElementVNode("button", {
                class: "icon-button add-param-button",
                title: "Create new message type",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewParam(true)))
              }, [
                _createVNode(_component_fa, { icon: "plus" })
              ])
            ]),
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ncStore.editingService.requestList, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  (!_ctx.editModeParams.includes(item.id))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", null, _toDisplayString(item.name), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getParamTypeString(item)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.constantValue), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(true, item.id)
                            }, _hoisted_16, 8, _hoisted_14),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDup(item)
                            }, _hoisted_19, 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDeleteParam(true, item.id)
                            }, _hoisted_22, 8, _hoisted_20)
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "editInput",
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                          }, null, 8, _hoisted_23), [
                            [_vModelText, item.name]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_SearchableDropDown, {
                            options: _ctx.allMessages,
                            "max-item": 10,
                            "initially-selected": (_ctx.globalStore.getMessage(item.msg) || _ctx.getPrimitiveMessages()[0]) as Message,
                            onSelected: (msg) => _ctx.chooseParamMsgType(true, item.id, msg)
                          }, null, 8, ["options", "initially-selected", "onSelected"])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            value: item.id,
                            checked: item.constantValue !== undefined,
                            onChange: () => _ctx.onConstBoxClicked(item)
                          }, null, 40, _hoisted_24),
                          (item.constantValue !== undefined)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "editInput",
                                "onUpdate:modelValue": ($event: any) => ((item.constantValue) = $event)
                              }, null, 8, _hoisted_25)), [
                                [_vModelText, item.constantValue]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(true, item.id)
                            }, _hoisted_29, 8, _hoisted_27),
                            _hoisted_30,
                            _hoisted_31
                          ])
                        ])
                      ], 64))
                ]))
              }), 128))
            ]),
            _createElementVNode("h3", null, [
              _createTextVNode(" Response Params "),
              _createElementVNode("button", {
                class: "icon-button add-param-button",
                title: "Create new message type",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addNewParam(false)))
              }, [
                _createVNode(_component_fa, { icon: "plus" })
              ])
            ]),
            _createElementVNode("table", _hoisted_32, [
              _hoisted_33,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ncStore.editingService.responseList, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  (!_ctx.editModeParams.includes(item.id))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", null, _toDisplayString(item.name), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getParamTypeString(item)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.constantValue), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(false, item.id)
                            }, _hoisted_37, 8, _hoisted_35),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDup(item)
                            }, _hoisted_40, 8, _hoisted_38),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDeleteParam(false, item.id)
                            }, _hoisted_43, 8, _hoisted_41)
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "editInput",
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                          }, null, 8, _hoisted_44), [
                            [_vModelText, item.name]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_SearchableDropDown, {
                            options: _ctx.allMessages,
                            "max-item": 10,
                            "initially-selected": 
                    (_ctx.globalStore.getMessage(item.msg) || _ctx.getPrimitiveMessages()[0]) as Message
                  ,
                            onSelected: (msg) => _ctx.chooseParamMsgType(false, item.id, msg)
                          }, null, 8, ["options", "initially-selected", "onSelected"])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            value: item.id,
                            checked: item.constantValue !== undefined,
                            onChange: () => _ctx.onConstBoxClicked(item)
                          }, null, 40, _hoisted_45),
                          (item.constantValue !== undefined)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "editInput",
                                "onUpdate:modelValue": ($event: any) => ((item.constantValue) = $event)
                              }, null, 8, _hoisted_46)), [
                                [_vModelText, item.constantValue]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(false, item.id)
                            }, _hoisted_50, 8, _hoisted_48),
                            _hoisted_51,
                            _hoisted_52
                          ])
                        ])
                      ], 64))
                ]))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                (_ctx.ncStore.editingService.server !== undefined)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.ncStore.editingService.serverObj()?.name), 1),
                        _createElementVNode("button", {
                          class: "del-btn",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ncStore.editingService?.removeServer()))
                        }, " Delete ")
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.ncStore.editingService.clients.length !== 0)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_55, "Clients"))
                  : _createCommentVNode("", true),
                (_ctx.ncStore.editingService.clients.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ncStore.editingService.clientObjs(), (client) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "del-container",
                          key: client.id
                        }, [
                          _createElementVNode("p", null, _toDisplayString(client.name), 1),
                          _createElementVNode("button", {
                            class: "del-btn",
                            onClick: ($event: any) => (_ctx.ncStore.editingService?.removeClient(client))
                          }, " Delete ", 8, _hoisted_57)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "dialog-bg",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onExitModal()))
        })
      ], 64))
    : _createCommentVNode("", true)
}